import { ReactNode, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

type Props = {
    children: ReactNode
    trigger: ReactNode
}

const Popup = (props: Props) => {

    return (
        <Popover className="relative">
            {
                ({}) => (
                    <>
                        <Popover.Button as="div" className="focus:ring-0 focus:outline-none">
                            {props.trigger}
                        </Popover.Button>

                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-300 origin-top"
                            enterFrom="transform opacity-0 scale-y-95"
                            enterTo="transform opacity-100 scale-y-100"
                            leave="transition ease-in duration-300 origin-top"
                            leaveFrom="transform opacity-100 scale-y-100"
                            leaveTo="transform opacity-0 scale-y-95"
                        >
                            <Popover.Panel className="absolute left-1/3 z-10 mt-4 transform -translate-x-1/2">
                                <div className="relative">
                                    <div className={twMerge(`before:absolute before:-top-2 before:left-1/2 
                                    before:bg-white before:w-4 before:h-4 before:rotate-45 before:border 
                                    before:border-zinc-200`)} />
                                    <div className="relative z-10">
                                        {props.children}
                                    </div>
                                </div>
                            </Popover.Panel>
                        </Transition>
                    </>
                )
            }
        </Popover>
    )
}

export default Popup